import React from "react";
import { getGreeting } from "../../utils/dashboardHelpers";

const DashboardHeader = ({ userName, currentTime, onRefresh }) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex-1">
        <h1 className="text-2xl sm:text-3xl font-bold text-white break-words">
          {getGreeting()}, {userName}!
        </h1>
        <p className="text-gray-400 mt-1 text-sm sm:text-base">
          Here's what's happening with your agency today.
        </p>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <div className="hidden md:flex items-center gap-2 px-4 py-2 glass rounded-xl flex-shrink-0">
          <div className="w-2 h-2 bg-neon-green rounded-full animate-pulse flex-shrink-0" />
          <span className="text-sm text-gray-300 whitespace-nowrap">
            {currentTime.toLocaleDateString("en-IN", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>
        <button
          onClick={onRefresh}
          className="btn-outline-neon flex items-center gap-2 whitespace-nowrap"
        >
          <svg
            className="w-5 h-5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span className="hidden sm:inline">Refresh</span>
        </button>
      </div>
    </div>
  );
};

export default DashboardHeader;
